/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListToolCallsQueryResponse, IncidentInvestigationControllerListToolCallsPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListToolCalls";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { incidentInvestigationControllerListToolCalls } from "../../clients/incident-agentService/incidentInvestigationControllerListToolCalls";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const incidentInvestigationControllerListToolCallsQueryKey = (id: IncidentInvestigationControllerListToolCallsPathParams["id"]) => [{
  url: '/api/v1/incident-agent/investigations/:id/tool-calls',
  params: {
    id: id
  }
}] as const;
export type IncidentInvestigationControllerListToolCallsQueryKey = ReturnType<typeof incidentInvestigationControllerListToolCallsQueryKey>;
export function incidentInvestigationControllerListToolCallsQueryOptions(id: IncidentInvestigationControllerListToolCallsPathParams["id"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = incidentInvestigationControllerListToolCallsQueryKey(id);
  return queryOptions<IncidentInvestigationControllerListToolCallsQueryResponse, ResponseErrorConfig<Error>, IncidentInvestigationControllerListToolCallsQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return incidentInvestigationControllerListToolCalls(id, config);
    }
  });
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/tool-calls}
 */
export function useIncidentInvestigationControllerListToolCalls<TData = IncidentInvestigationControllerListToolCallsQueryResponse, TQueryData = IncidentInvestigationControllerListToolCallsQueryResponse, TQueryKey extends QueryKey = IncidentInvestigationControllerListToolCallsQueryKey>(id: IncidentInvestigationControllerListToolCallsPathParams["id"], options: {
  query?: Partial<QueryObserverOptions<IncidentInvestigationControllerListToolCallsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? incidentInvestigationControllerListToolCallsQueryKey(id);
  const query = useQuery({
    ...incidentInvestigationControllerListToolCallsQueryOptions(id, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}